/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "bookingapi",
            "endpoint": "https://hcb9cd9py0.execute-api.ap-southeast-1.amazonaws.com/stg",
            "region": "ap-southeast-1"
        }
    ]
};


export default awsmobile;
